/**
 * Mesclagem de contatos (#4408): o que o seletor oferece e o que ele bloqueia.
 *
 * A busca mostra todo contato que a API devolveu, menos o próprio `target`.
 * Os que não podem ser mesclados NÃO somem: aparecem desabilitados com o
 * motivo. Esconder calado fez parecer que a busca estava quebrada (18-09).
 */
export const mergeCandidates = (list, target) => {
  if (!Array.isArray(list) || !target) return [];
  return list.filter(c => c.id !== target.id);
};

/**
 * Por que `candidate` não pode ser absorvido por `target` — chave de
 * `mergeContactModal.blocked.*` — ou null se pode. Espelha a trava do backend
 * (`CONTACT_ERRORS.MERGE_TYPE_MISMATCH`): grupo só com grupo. Canal diferente
 * é permitido.
 */
export const mergeBlockReason = (candidate, target) => {
  if (!candidate || !target) return null;
  if (Boolean(candidate.isGroup) !== Boolean(target.isGroup)) return "typeMismatch";
  return null;
};
